import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { AssetList } from './AssetList';
import { PortfolioChart } from './PortfolioChart';
import { PnLSummary } from './PnLSummary';
import { useWallet } from '../wallet/WalletProvider';

export function PortfolioDashboard() {
  const { isConnected } = useWallet();

  if (!isConnected) {
    return (
      <Card className="max-w-md mx-auto">
        <CardHeader>
          <CardTitle>Portfolio Dashboard</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <p className="text-slate-600 dark:text-slate-400">
            Connect your wallet to view your portfolio and track your assets.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100">Portfolio</h1>
        <p className="text-slate-600 dark:text-slate-400 mt-2">
          Track your assets, monitor performance, and analyze your crypto portfolio
        </p>
      </div>

      {/* P&L Summary */}
      <PnLSummary />

      {/* Portfolio Chart & Assets */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <PortfolioChart />
        </div>
        <div>
          <AssetList />
        </div>
      </div>
    </div>
  );
}